module.exports = __webpack_public_path__ + "static/media/headerLogo.1d9981b8.png";